import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "../lib/theme";

/** Compact theme toggle (☀️ / 🌙). Used in Footer + Navbar. */
export default function ThemeToggle({ className = "", compact = false }) {
  const [theme, toggle] = useTheme();
  const isDark = theme === "dark";
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? "Passa al tema chiaro" : "Passa al tema scuro"}
      title={isDark ? "Tema chiaro" : "Tema scuro"}
      className={
        compact
          ? `inline-flex items-center justify-center h-9 w-9 rounded-full hover:bg-zinc-100 dark:hover:bg-zinc-800 text-zinc-600 dark:text-zinc-300 transition ${className}`
          : `inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full bg-zinc-100 hover:bg-zinc-200 dark:bg-zinc-800 dark:hover:bg-zinc-700 dark:text-zinc-200 transition ${className}`
      }
      data-testid="theme-toggle"
    >
      {isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
      {!compact && <span>{isDark ? "Chiaro" : "Scuro"}</span>}
    </button>
  );
}
